/* Keeps the commercial-order cart attributes in sync with the real cart.
   10+ units => attributes commercial_order/commercial_quantity land on the
   order as note attributes for the sales follow-up workflow. Shopify Flow
   tags the order from actual line quantities as well — these attributes are
   an advisory marker, not the mechanism. Single-product store: every cart
   unit is a Combat Mirror, so summing all items is safe. */
(function () {
  const THRESHOLD = 10;
  let syncing = false;

  async function sync() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const units = cart.items.reduce((sum, item) => sum + item.quantity, 0);
      const desired =
        units >= THRESHOLD
          ? { commercial_order: 'true', commercial_quantity: String(units) }
          : { commercial_order: '', commercial_quantity: '' };
      const current = cart.attributes || {};
      if (
        (current.commercial_order || '') === desired.commercial_order &&
        (current.commercial_quantity || '') === desired.commercial_quantity
      ) {
        return;
      }
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: desired }),
      });
    } catch {
      /* non-critical: Flow tags from real quantities regardless */
    } finally {
      syncing = false;
    }
  }

  // PUB_SUB_EVENTS/subscribe are top-level const/function declarations in
  // Dawn's constants.js/pubsub.js — script-global but not window properties.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => sync());
  }
  sync();
})();
